// extracted by mini-css-extract-plugin
module.exports = {"root":"NoShows_root__1CG7z"};